import { createAction, props } from '@ngrx/store';

import { type PropertiesEditorCanvasElementOverrides } from '@blaze-shared/elements-domain';
import { type LayoutStyleReferencesInfo, type StyleSheet } from '@blaze-shared/theming-domain';

const TAG = '[Styles]';

export const loadStylesSheets = createAction(
  `${TAG} Load style sheets`,
  props<{ projectId: string; includeReferences?: boolean }>(),
);

export const loadStyleSheetsReadyForMigration = createAction(
  `${TAG} Load style sheets ready for migration`,
  props<{ styleSheets: StyleSheet[]; updateMode?: boolean; projectId: string }>(),
);

export const loadStyleSheetsSuccess = createAction(
  `${TAG} Load style sheets success`,
  props<{ styleSheets: StyleSheet[]; updateMode?: boolean; projectId: string }>(),
);

export const loadStyleSheetsFailure = createAction(
  `${TAG} Load style sheets failure`,
  props<{ error: string }>(),
);

export const createStyleSheet = createAction(
  `${TAG} Create style sheet`,
  props<{
    name: string;
    elementId: string;
    slotId?: string;
    elementType: string;
    projectId: string;
    props: any;
    overrides: PropertiesEditorCanvasElementOverrides | undefined;
    themeId: string | undefined;
    setDefault?: boolean;
    version: number;
  }>(),
);

export const createStyleSheetSuccess = createAction(
  `${TAG} Create style sheet success`,
  props<{
    styleSheet: StyleSheet;
    elementId?: string;
    slotId?: string;
  }>(),
);

export const createStyleSheetFailure = createAction(
  `${TAG} Create style sheet failure`,
  props<{ error: string }>(),
);

export const updateStyleSheet = createAction(
  `${TAG} Update style sheet`,
  props<{
    name: string;
    id: string;
    current: StyleSheet;
    elementId: string;
    slotId?: string;
    elementType: string;
    projectId: string;
    props: any;
    overrides: PropertiesEditorCanvasElementOverrides | undefined;
    setDefault?: boolean;
    version: number;
  }>(),
);

export const updateStyleSheetSuccess = createAction(
  `${TAG} Update style sheet success`,
  props<{
    styleSheet: StyleSheet;
    elementId?: string;
    slotId?: string;
  }>(),
);

export const updateStyleSheetFailure = createAction(
  `${TAG} Update style sheet failure`,
  props<{ error: string }>(),
);

export const deleteStyleSheet = createAction(`${TAG} Delete style sheet`, props<{ id: string }>());

export const deleteStyleSheetSuccess = createAction(
  `${TAG} Delete style sheet success`,
  props<{ id: string }>(),
);

export const deleteStyleSheetFailure = createAction(
  `${TAG} Delete style sheet failure`,
  props<{ error: string }>(),
);

export const updateReferences = createAction(
  `${TAG} Update references`,
  props<{ pageId: string; references: LayoutStyleReferencesInfo[] }>(),
);

export const setDefaultStyleSheet = createAction(
  `${TAG} Set default style sheet`,
  props<{ id: string; hideNotification?: boolean }>(),
);

export const setDefaultStyleSheetSuccess = createAction(
  `${TAG} Set default style sheet success`,
  props<{ styleSheet: StyleSheet }>(),
);

export const refreshStyleSheets = createAction(`${TAG} Refresh style sheets`);
